// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"595b5865","453":"e19af074","625":"59d7dbdc"}[chunkId] + ".chunk.js";
};